import i18n from './i18n';

const API_BASE = process.env.REACT_APP_API_URL || '';

const req = (method, path, body) => {
  const token = localStorage.getItem('sp_token');
  return fetch(`${API_BASE}/api${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async r => {
    if (r.status === 401) {
      localStorage.removeItem('sp_token');
      window.location.href = '/login';
      return;
    }
    const data = await r.json();
    if (!r.ok) throw new Error(data.error || 'Błąd serwera');
    return data;
  });
};

export const api = {
  // Auth
  login: (email, haslo) => req('POST', '/auth/login', { email, haslo }),
  register: (email, haslo, imie) => req('POST', '/auth/register', { email, haslo, imie }),
  me: () => req('GET', '/auth/me'),
  logout: () => { localStorage.removeItem('sp_token'); },
  getSettings: () => req('GET', '/auth/settings'),
  saveSettings: (data) => req('PUT', '/auth/settings', data),
  changePassword: (stare_haslo, nowe_haslo) => req('PUT', '/auth/change-password', { stare_haslo, nowe_haslo }),
  forgotPassword: (email) => req('POST', '/auth/forgot-password', { email }),
  resetPassword: (token, nowe_haslo) => req('POST', '/auth/reset-password', { token, nowe_haslo }),
  verifyEmail: (token) => req('POST', '/auth/verify-email', { token }),
  resendVerify: () => req('POST', '/auth/resend-verify'),
  changeEmail: (newEmail) => req('POST', '/auth/change-email', { email: newEmail }),
  setLang: (lang) => req('POST', '/auth/lang', { lang }),
  welcomeDismiss: () => req('POST', '/auth/welcome-dismiss'),
  onboardingDismiss: () => req('POST', '/auth/onboarding-dismiss'),
  onboardingSkipStep: (step, skip = true) => req('POST', '/auth/onboarding-skip-step', { step, skip }),

  // Raport PDF klienta
  pobierzRaportPDF: (id, konfiguracja = {}) => {
    const token = localStorage.getItem('sp_token');
    const qs = new URLSearchParams();
    if (konfiguracja.scope)           qs.set('scope', konfiguracja.scope);
    if (konfiguracja.spacery_ids?.length) qs.set('spacery_ids', konfiguracja.spacery_ids.join(','));
    if (konfiguracja.pakiet_id)       qs.set('pakiet_id', konfiguracja.pakiet_id);
    if (konfiguracja.symulacja_data)  qs.set('symulacja_data', konfiguracja.symulacja_data);
    if (konfiguracja.statusy?.length) qs.set('statusy', konfiguracja.statusy.join(','));
    qs.set('lang', i18n.language || 'pl');
    return fetch(`${API_BASE}/api/klienci/${id}/raport.pdf?${qs}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(async r => {
      if (!r.ok) { const d = await r.json(); throw new Error(d.error || 'Błąd serwera'); }
      return r.blob();
    });
  },
  wyslijRaport: (id, email_do, wiadomosc, konfiguracja = {}) =>
    req('POST', `/klienci/${id}/raport/wyslij`, {
      email_do, wiadomosc,
      konfiguracja: { ...konfiguracja, lang: i18n.language || 'pl' },
    }),

  // Faktury — PDF załączniki
  uploadFakturaPdf: (id, file) => {
    const token = localStorage.getItem('sp_token');
    return fetch(`${API_BASE}/api/faktury/${id}/pdf`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/pdf',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: file,
    }).then(async r => {
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.error || 'Błąd uploadu');
      return data;
    });
  },
  downloadFakturaPdf: (id, filename) => {
    const token = localStorage.getItem('sp_token');
    return fetch(`${API_BASE}/api/faktury/${id}/pdf`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(async r => {
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Błąd pobierania'); }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename || `faktura-${id}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    });
  },
  deleteFakturaPdf: (id) => req('DELETE', `/faktury/${id}/pdf`),

  // Pakiety — PDF załączniki (faktury sprzedaży pakietów)
  uploadPakietPdf: (id, file) => {
    const token = localStorage.getItem('sp_token');
    return fetch(`${API_BASE}/api/pakiety/${id}/pdf`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/pdf',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: file,
    }).then(async r => {
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.error || 'Błąd uploadu');
      return data;
    });
  },
  downloadPakietPdf: (id, filename) => {
    const token = localStorage.getItem('sp_token');
    return fetch(`${API_BASE}/api/pakiety/${id}/pdf`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(async r => {
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Błąd pobierania'); }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename || `pakiet-${id}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    });
  },
  deletePakietPdf: (id) => req('DELETE', `/pakiety/${id}/pdf`),

  // Widoczność w panelu klienta — toggle dla faktur i pakietów
  setFakturaWidoczna: (id, widoczna) =>
    req('PUT', `/faktury/${id}/widoczna`, { widoczna: widoczna ? 1 : 0 }),
  setPakietWidoczna: (id, widoczna) =>
    req('PUT', `/pakiety/${id}/widoczna`, { widoczna: widoczna ? 1 : 0 }),

  // Faktury (cross-klient)
  getFakturyAll: () => req('GET', '/faktury'),
  getFakturyPodsumowanie: (rok, miesiac) => {
    const qs = new URLSearchParams();
    if (rok) qs.set('rok', rok);
    if (miesiac) qs.set('miesiac', miesiac);
    return req('GET', `/faktury/podsumowanie${qs.toString() ? '?' + qs : ''}`);
  },
  setFakturaStatus: (id, status, data_wplaty) =>
    req('PUT', `/faktury/${id}/status`, { status, data_wplaty }),
  setPakietStatus: (id, status, data_platnosci) =>
    req('PUT', `/pakiety/${id}/status`, { status, data_platnosci }),

  // Klienci — preview-token: wyemituj klient-JWT, fotograf otwiera panel klienta
  klientPreviewToken: (id) => req('POST', `/klienci/${id}/preview-token`),

  // Klienci
  getKlienci: () => req('GET', '/klienci'),
  getKlient: id => req('GET', `/klienci/${id}`),
  addKlient: data => req('POST', '/klienci', data),
  updateKlient: (id, data) => req('PUT', `/klienci/${id}`, data),
  deleteKlient: id => req('DELETE', `/klienci/${id}`),

  // Spacery
  getSpacery: params => {
    const qs = params ? '?' + new URLSearchParams(params) : '';
    return req('GET', `/spacery${qs}`);
  },
  getSpacer: id => req('GET', `/spacery/${id}`),
  addSpacer: data => req('POST', '/spacery', data),
  updateSpacer: (id, data) => req('PUT', `/spacery/${id}`, data),
  deleteSpacer: id => req('DELETE', `/spacery/${id}`),
  scrapeMatterport: url => req('POST', '/scrape-matterport', { url }),

  // Faktury klienta (głowa + pozycje, jedna faktura ↔ N spacerów)
  getKlientFaktury: klient_id => req('GET', `/klienci/${klient_id}/faktury`),
  podgladKlientFaktury: (klient_id, spacery) => req('POST', `/klienci/${klient_id}/faktury/podglad`, { spacery }),
  addKlientFaktura: (klient_id, data) => req('POST', `/klienci/${klient_id}/faktury`, data),
  updateKlientFaktura: (klient_id, id, data) => req('PUT', `/klienci/${klient_id}/faktury/${id}`, data),
  updateKlientFakturaStatus: (klient_id, id, status, data_wplaty) =>
    req('PUT', `/klienci/${klient_id}/faktury/${id}/status`, { status, data_wplaty }),
  deleteKlientFaktura: (klient_id, id) => req('DELETE', `/klienci/${klient_id}/faktury/${id}`),

  // Wpłaty za hosting (legacy: pojedyncza pozycja faktury per-spacer)
  getPlatnosci: spacer_id => req('GET', `/spacery/${spacer_id}/platnosci`),
  podgladPlatnosci: (spacer_id, data) => req('POST', `/spacery/${spacer_id}/platnosci/podglad`, data),
  addPlatnosc: (spacer_id, data) => req('POST', `/spacery/${spacer_id}/platnosci`, data),
  updatePlatnoscStatus: (spacer_id, id, status, data_wplaty) =>
    req('PUT', `/spacery/${spacer_id}/platnosci/${id}/status`, { status, data_wplaty }),
  updatePlatnosc: (spacer_id, id, data) =>
    req('PUT', `/spacery/${spacer_id}/platnosci/${id}`, data),
  deletePlatnosc: (spacer_id, id) => req('DELETE', `/spacery/${spacer_id}/platnosci/${id}`),

  // Koszty Matterport
  getKoszty: () => req('GET', '/koszty'),
  saveKoszt: data => req('POST', '/koszty', data),

  // Koszty dodatkowe
  getKosztyDodatkowe: (rok, miesiac) => {
    const qs = new URLSearchParams({ rok, ...(miesiac ? { miesiac } : {}) });
    return req('GET', `/koszty-dodatkowe?${qs}`);
  },
  addKosztDodatkowy: data => req('POST', '/koszty-dodatkowe', data),
  deleteKosztDodatkowy: id => req('DELETE', `/koszty-dodatkowe/${id}`),

  // Abonament Matterport roczny
  getKosztyMPRoczny: () => req('GET', '/koszty-matterport-roczny'),
  saveKosztMPRoczny: data => req('POST', '/koszty-matterport-roczny', data),

  // Pakiety spacerów
  getPakiety: () => req('GET', '/pakiety'),
  addPakiet: data => req('POST', '/pakiety', data),
  updatePakiet: (id, data) => req('PUT', `/pakiety/${id}`, data),
  deletePakiet: id => req('DELETE', `/pakiety/${id}`),

  // Zdarzenia (Kalendarz)
  getZdarzenia: (od, doDate) => req('GET', `/zdarzenia${od ? `?od=${od}&do=${doDate}` : ''}`),
  addZdarzenie: (data) => req('POST', '/zdarzenia', data),
  updateZdarzenie: (id, data) => req('PUT', `/zdarzenia/${id}`, data),
  deleteZdarzenie: (id) => req('DELETE', `/zdarzenia/${id}`),
  getIcalToken: () => req('GET', '/ical/token'),
  generateIcalToken: () => req('POST', '/ical/token'),
  deleteIcalToken: () => req('DELETE', '/ical/token'),

  // Admin
  adminGetStats: () => req('GET', '/admin/stats'),
  adminBackupDb: () => {
    // Token w nagłówku Authorization — nie w query, żeby nie wyciekał do logów / Refererów.
    const token = localStorage.getItem('sp_token');
    return fetch(`${API_BASE}/api/admin/backup-db`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }).then(async r => {
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Błąd serwera'); }
      return r.blob();
    });
  },
  adminGetUsers: () => req('GET', '/admin/users'),
  adminPatchUser: (id, data) => req('PATCH', `/admin/users/${id}`, data),
  adminDeleteUser: (id) => req('DELETE', `/admin/users/${id}`),
  adminImpersonate: (id) => req('POST', `/admin/impersonate/${id}`),
  adminGetUser: (id) => req('GET', `/admin/users/${id}`),

  // Beta invites — outreach do fotografów
  adminGetInvites:    ()        => req('GET',    '/admin/invites'),
  adminAddInvite:     (data)    => req('POST',   '/admin/invites', data),
  adminUpdateInvite:  (id, d)   => req('PATCH',  `/admin/invites/${id}`, d),
  adminDeleteInvite:  (id)      => req('DELETE', `/admin/invites/${id}`),
  adminGrantAccess:   (id, customMessage) => req('POST', `/admin/invites/${id}/grant-access`, customMessage ? { custom_message: customMessage } : {}),
  adminSendIntro:     (id)      => req('POST',   `/admin/invites/${id}/send-intro`),
  adminSendFeedback:  (id)      => req('POST',   `/admin/invites/${id}/send-feedback`),

  // Leady (cold outreach) — przyjmują obiekt query który składamy w URLSearchParams.
  adminGetLeads:        (query)  => req('GET',    '/admin/leads' + (query ? '?' + new URLSearchParams(query).toString() : '')),
  adminGetLead:         (id)     => req('GET',    `/admin/leads/${id}`),
  adminAddLead:         (data)   => req('POST',   '/admin/leads', data),
  adminImportLeads:     (data)   => req('POST',   '/admin/leads/import', data),
  adminUpdateLead:      (id, d)  => req('PATCH',  `/admin/leads/${id}`, d),
  adminDeleteLead:      (id)     => req('DELETE', `/admin/leads/${id}`),
  adminSendLeadInvite:  (id, d)  => req('POST',   `/admin/leads/${id}/send-invite`, d || {}),

  // Kolejka cold-outreach scheduler
  adminScheduleBatchLeads:   (data)  => req('POST',   '/admin/leads/schedule-batch', data),
  adminUnscheduleLead:       (id)    => req('POST',   `/admin/leads/${id}/unschedule`),
  adminUnscheduleBatchLeads: (data)  => req('POST',   '/admin/leads/unschedule-batch', data),
  adminGetLeadsQueue:        ()     => req('GET',    '/admin/leads/queue'),

  // Email templates
  adminGetEmailTemplates:    ()                  => req('GET',  '/admin/email-templates'),
  adminUpdateEmailTemplate:  (key, data)         => req('PUT',  `/admin/email-templates/${key}`, data),
  adminPreviewEmailTemplate: (key, data)         => req('POST', `/admin/email-templates/${key}/preview`, data || {}),
  adminResetEmailTemplate:   (key)               => req('POST', `/admin/email-templates/${key}/reset`),

  // SaaS finanse
  adminGetSaasConfig:    ()       => req('GET',    '/admin/saas/config'),
  adminSaveSaasConfig:   (data)   => req('PUT',    '/admin/saas/config', data),
  adminGetSaasReport:    ()       => req('GET',    '/admin/saas/report'),
  adminGetSaasPayments:  ()       => req('GET',    '/admin/saas/payments'),
  adminAddSaasPayment:   (data)   => req('POST',   '/admin/saas/payments', data),
  adminUpdateSaasPayment:(id, d)  => req('PUT',    `/admin/saas/payments/${id}`, d),
  adminDeleteSaasPayment:(id)     => req('DELETE', `/admin/saas/payments/${id}`),

  // Czat wsparcia
  getCzat: () => req('GET', '/czat'),
  sendCzat: tresc => req('POST', '/czat', { tresc }),
  wznowCzat: () => req('POST', '/czat/wznow'),
  czatNieprzeczytane: () => req('GET', '/czat/nieprzeczytane'),
  adminCzatNieprzeczytane: () => req('GET', '/admin/czat/nieprzeczytane'),
  adminGetCzatUsers: () => req('GET', '/admin/czat'),
  adminGetCzatUser: id => req('GET', `/admin/czat/${id}`),
  adminSendCzat: (id, tresc) => req('POST', `/admin/czat/${id}`, { tresc }),
  adminZakonczCzat: id => req('POST', `/admin/czat/${id}/zakoncz`),
  adminWznowCzat: id => req('POST', `/admin/czat/${id}/wznow`),

  // Dashboard
  getDashboard: (rok, miesiac) => {
    const qs = new URLSearchParams({ ...(rok ? { rok } : {}), ...(miesiac != null ? { miesiac } : {}) });
    return req('GET', `/dashboard?${qs}`);
  },
};
